import { getParamsFromObj } from '../utils/queryBuilder';
import orderApiInstance from './axiosInstances/orderService';

export const fetchbillingRequestIds = ({ userId, statuses = [] }) => {
  return orderApiInstance.get(
    `/billing-request/user-id/${userId}/statuses${statuses
      .map((status, i) => getParamsFromObj(status, i === 0))
      .join('')}`
  );
};

export const fetchSourceTargetPrograms = ({ ids = [] }) => {
  return orderApiInstance.get(
    `/v2/billing-request/transferred/details${ids
      .map((id, i) => getParamsFromObj(id, i === 0))
      .join('')}`
  );
};

export const fetchDetailsByBillingRequestIdApi = (id) => {
  return orderApiInstance.get(`/v2/billing-request/${id}/details`);
};

export const fetchAppliedCouponsByBillingRequestId = (id) => {
  return orderApiInstance.get(`/discount/applied-coupons/${id}`);
};

export const revokeCouponByCouponCodes = (payload) => {
  return orderApiInstance.post(`/discount/revoke`, payload);
};
